import Client from 'config/axios';
import posthog from 'posthog-js';

export const deleteBonus = async (token: string, bonusId: number) => {
  try {
    const { data } = await Client.delete(`bonus/${bonusId}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    posthog.capture('DeleteBonus', {
      DeleteBonus: data
    });
    return { data };
  } catch (response) {
    const result = response as any;
    return { errors: result.data };
  }
};
